<template>
  <div class="tab-content sort-type" id="app-stat-list-template">
    <div class="job-list-container">
      <div v-if="list.length === 0">
        <div class=no-data>{{ infoText }}</div>
      </div>
      <div v-else>
        <ul class="job-card-grid new-type">
          <li class="job-card" v-for="result in list" :key="result.APP_NO">
            <a href="javascript:void(0)" title="가치동행일자리 {{ result.BIZ_CD_NM }} {{ result.BIZ_CD_NM }} {{ result.BIZ_CD_NM }} {{">
              <div class="card-header flex-justify-between">
                <span class="job-tag type2" v-if="annKindType === 'JB'">가치동행일자리</span>
                <span class="job-tag type1" v-else-if="result.BIZ_SE === 'IN49001'">{{ result.BIZ_CD_NM }}</span>
                <span class="job-tag type2" v-else-if="result.BIZ_SE === 'IN49003'">{{ result.BIZ_CD_NM }}</span>
                <span class="job-tag type3" v-else-if="result.BIZ_SE === 'IN49006'">{{ result.BIZ_CD_NM }}</span>
                <span class="job-tag type4" v-else-if="result.BIZ_SE === 'IN49007'">{{ result.BIZ_CD_NM }}</span>
                <span class="job-tag type5" v-else-if="result.BIZ_SE === 'IN49008'">{{ result.BIZ_CD_NM }}</span>
                <span class="job-tag type1" v-else-if="result.BIZ_SE === 'IN49009'">{{ result.BIZ_CD_NM }}</span>
                <span class="job-tag type2" v-else-if="result.BIZ_SE === 'IN49004'">기타</span>
                <span class="status-badge" :class="result.classColor">{{result.codeLabel}}</span>
              </div>
              <div class="card-body">
                <span class="sub-title" v-if="result.CORPR_ORG !== null">{{ result.CORPR_ORG }}</span>
                <span class="title-line">{{ result.ANN_NM | decodeHtml }}</span>
                <div>
                  <span class="label-status">{{ result.ANN_RCRT_STAT_NM }}</span>
                </div>
                <dl class="recruitment-info">
                  <dt>모집기간 :</dt>
                  <dd>{{ result.APPDURNG_ST }}~{{ result.APPDURNG_ED }}</dd>
                  <template v-if="result.BIZ_YEAR !== '' && result.BIZ_YEAR !== null">
                    <dt>사업년도 :</dt>
                    <dd>{{ result.BIZ_YEAR }}</dd>
                  </template>
                  <template v-if="result.OPER_ORG_NM !== '' && result.OPER_ORG_NM !== null">
                    <dt>운영기관 :</dt>
                    <dd class="multiline-ellipsis">{{ result.OPER_ORG_NM }}</dd>
                  </template>
                </dl>
                <div class="button-area mypage-type1 mt-0">
                  <button class="btn btn-secondary btn-md appView" @click="showAppViewModal(result.APP_NO, result.ANN_NO)">신청 정보 보기</button>
                  <button class="btn btn-primary btn-md" @click="showAnnDetailModal(result.APP_NO, result.ANN_NO)">공고 상세 보기</button>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <pagination :totalPages="paginationInfo.totalPageCount" :currentPage.sync="paginationInfo.currentPageNo" :size="paginationInfo.pageSize" @update:currentPage="handlePageChange"></pagination>
      <app-view-modal :appViewModal="appViewModal" :annKindType="annKindType" :appNo="seletedAppNo" :annNo="seletedAnnNo" :bizSe="seletedBizSe" @update:appViewModal="appViewModal = $event" @appAdditionEdit="appAdditionEdit"></app-view-modal>
      <company-app-view-modal :companyAppViewModal="companyAppViewModal" :annKindType="annKindType" :appNo="seletedAppNo" :annNo="seletedAnnNo" @update:companyAppViewModal="companyAppViewModal = $event"></company-app-view-modal>
      <ann-detail-modal :annDetailModal="annDetailModal" :annKindType="annKindType" :appNo="seletedAppNo" :annNo="seletedAnnNo" @update:annDetailModal="annDetailModal = $event"></ann-detail-modal>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import Pagination from '../../shared/Pagination.vue';
import AppViewModal from './AppView.vue';
import CompanyAppViewModal from './CompanyAppView.vue';
import AnnDetailModal from './AnnDetail.vue';

export default {
  name: 'app-stat-list-template',
  props: ['annKindType', 'isCompanyMember'],
  components: {
    Pagination,
    AppViewModal,
    CompanyAppViewModal,
    AnnDetailModal,
  },
  data() {
    return {
      list: [],
      paginationInfo: {},
      pagingParam: {
        pageIndex: 1, // 현재 페이지
        pageUnit: 12, // 한 페이지당 목록 수
        pageSize: 10, // 페이징 리스트
      },
      seletedAppNo: 0,
      seletedAnnNo: 0,
      appViewModal: false,
      companyAppViewModal: false,
      annDetailModal: false,
      infoText: '',
      lastFocusedElement: null,
    };
  },
  watch: {
    pageIndex: {
      handler() {
        this.getList();
      },
    },
    annDetailModal: {
      handler(newVal, oldVal) {
        if (!newVal && !this.appViewModal) $('body').removeClass('modal-open');
        if (oldVal === true && newVal === false) {
          this.getList();
          // 모달 닫힘 시 트리거 버튼으로 포커스 복귀
          this.$nextTick(() => {
            if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') {
              this.lastFocusedElement.focus();
              this.lastFocusedElement = null;
            }
          });
        }
      },
    },
    appViewModal: {
      handler(newVal, oldVal) {
        if (!newVal && !this.annDetailModal && !this.companyAppViewModal) $('body').removeClass('modal-open');
        // 모달 닫힘 시 트리거 버튼으로 포커스 복귀
        if (oldVal === true && newVal === false) {
          this.$nextTick(() => {
            if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') {
              this.lastFocusedElement.focus();
              this.lastFocusedElement = null;
            }
          });
        }
      },
    },
    companyAppViewModal: {
      handler(newVal, oldVal) {
        if (!newVal && !this.annDetailModal && !this.appViewModal) $('body').removeClass('modal-open');
        // 모달 닫힘 시 트리거 버튼으로 포커스 복귀
        if (oldVal === true && newVal === false) {
          this.$nextTick(() => {
            if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') {
              this.lastFocusedElement.focus();
              this.lastFocusedElement = null;
            }
          });
        }
      },
    },
  },
  filters: {
    decodeHtml: function (value) {
      if (!value) return '';

      // 임시 textarea 요소 생성
      const textarea = document.createElement('textarea');

      // HTML 엔티티를 설정
      textarea.innerHTML = value;

      // 디코딩된 값을 반환
      return textarea.value;
    }
  },
  methods: {
    getList() {
      this.pagingParam.pageIndex = this.paginationInfo.currentPageNo;
      const url = (this.annKindType === 'JB') ? '/api/app/list' : '/api/in_app/list';
      Axios.get(url, { params: this.pagingParam }).then((response) => {
        const result = response.data.data;
        this.list = result.list.map((item) => {
          const newItem = { ...item };
          if (!item.JUDGE_ING_CD_NM) newItem.JUDGE_ING_CD_NM = '';
          return newItem;
        });
        this.paginationInfo = result.paginationInfo;
        if (this.list.length === 0) this.infoText = '일자리 신청 내역이 없습니다.';
      }).catch((e) => {
        console.error(e);
      });
    },
    handleResize() {
      const width = window.innerWidth;
      if (width <= 768) {
        this.pagingParam.pageSize = 5;
      } else {
        this.pagingParam.pageSize = 10;
      }
    },
    showAppViewModal(appNo, annNo) {
      this.lastFocusedElement = document.activeElement;  // 트리거 버튼 저장
      $('body').addClass('modal-open');
      this.seletedAppNo = appNo;
      this.seletedAnnNo = annNo;

      if (this.isCompanyMember) {
        this.companyAppViewModal = true;
      } else {
        this.appViewModal = true;
      }
      // 모달 열림 후 내부 첫 버튼으로 포커스 이동
      this.$nextTick(() => {
        setTimeout(() => {
          const modalEl = document.querySelector('.cmp-modal.is-active');
          if (modalEl) {
            const focusable = modalEl.querySelector('button:not([disabled]):not(.close-modal)');
            if (focusable) focusable.focus();
          }
        }, 100);
      });
    },
    showAnnDetailModal(appNo, annNo) {
      this.lastFocusedElement = document.activeElement;  // 트리거 버튼 저장
      $('body').addClass('modal-open');
      this.seletedAppNo = appNo;
      this.seletedAnnNo = annNo;
      this.annDetailModal = true;
      // 모달 열림 후 내부 첫 버튼으로 포커스 이동
      this.$nextTick(() => {
        setTimeout(() => {
          const modalEl = document.querySelector('.cmp-modal.is-active');
          if (modalEl) {
            const focusable = modalEl.querySelector('button:not([disabled]):not(.close-modal)');
            if (focusable) focusable.focus();
          }
        }, 100);
      });
    },
    handlePageChange(newPage) {
      this.paginationInfo.currentPageNo = newPage;
      this.getList();
    },
  },
  computed: {

  },
  created() {
    this.handleResize(); // 초기 로드 시 실행
    window.addEventListener('resize', this.handleResize); // 리사이즈 이벤트 리스너 추가
    this.getList();
  },
  mounted() {
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize); // 컴포넌트 파괴 시 리스너 제거
  },
};
</script>


// WEBPACK FOOTER //
// AppStatList.vue?c808df74